var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5456 9.52915C16.8699 9.84354 16.8675 10.3646 16.5404 10.676L11.9998 15L7.45934 10.676C7.13227 10.3646 7.12994 9.84355 7.45421 9.52916C7.75954 9.23314 8.24373 9.22971 8.55322 9.5214L11.9998 12.7697L15.4466 9.52137C15.7561 9.2297 16.2403 9.23313 16.5456 9.52915Z",
    fill: "#393D47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownClosed);
export default __webpack_public_path__ + "static/media/dropdownClosed.66d2304c670d55a887b7c759bbad52c8.svg";
export { ForwardRef as ReactComponent };